import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'app-request-body',
    templateUrl: './request-body.component.html',
    styleUrls: ['./request-body.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RequestBodyComponent {
    readonly model = input<any>();
    readonly formGroup = input<FormGroup>();

    public metaContentType: any = {
        id: 'contentType',
        name: 'Content Type',
        value: 'value',
        label: 'name',
        options: [
            { name: 'text/plain', value: 'text/plain' },
            { name: 'application/json', value: 'application/json' },
            { name: 'application/javascript', value: 'application/javascript' },
            { name: 'application/xml', value: 'application/xml' },
            { name: 'text/xml', value: 'text/xml' },
            { name: 'text/html', value: 'text/html' }
        ]
    };

    public metaEditable: any = { id: 'editable', name: 'Editable' };
    public metaContent: any = { id: 'content', name: 'Content', rows: 12, textStyle: '{"font-family":"monospace"}' };
}
